import { proxy } from 'valtio'
import { handleSignOut } from './Navbar/Account/components/utils'

const TIMEOUT_DURATION = 60000 * 30// 30 minutes
export interface AutoLogoutProxyType {
  isTimeoutModalShown: boolean
  inactivityTimeoutId: number | undefined
  logoutTimeoutId: number | undefined
}

export const resetInactivityTimeoutId = (): void => {
  clearTimeout(autoLogoutProxy.inactivityTimeoutId)
  autoLogoutProxy.inactivityTimeoutId = window.setTimeout(showTimeoutModal, TIMEOUT_DURATION)
}

export const resetLogoutTimeoutId = (): void => {
  clearTimeout(autoLogoutProxy.logoutTimeoutId)
  autoLogoutProxy.logoutTimeoutId = window.setTimeout(logoutUser, TIMEOUT_DURATION + 60000) //add 1 minute for the other timeout...BC
}

export const logoutUser = (): void => {
  void handleSignOut()
}
export const showTimeoutModal = (): void => {
  autoLogoutProxy.isTimeoutModalShown = true
}

export const hideTimeoutModal = (): void => {
  autoLogoutProxy.isTimeoutModalShown = false
  resetInactivityTimeoutId()
  resetLogoutTimeoutId()
}
export const autoLogoutProxy: AutoLogoutProxyType = proxy({
  inactivityTimeoutId: undefined,
  isTimeoutModalShown: false,
  logoutTimeoutId: undefined
})
